export enum LanguageCourseDecisionStatus {
  /// <summary>
  /// Donošenje odluke<br/>
  /// Generirano je mišljenje s prijedlogom na kojem je naznačeno da dijete nedovoljno dobro poznaje hrvatski jezik
  /// </summary>
  Generated = 1,
  /// <summary>
  /// Odobrena dopunska nastava (UO/GU)<br/>
  /// UO/GU je donio odluku da se odobrava provođenje dopunske nastave za školskog obveznika
  /// </summary>
  SupplementaryCourseApproved = 2,
  /// <summary>
  /// Odobrena pripremna nastava (UO/GU)<br/>
  /// UO/GU je donio odluku da se odobrava provođenje pripremne nastave za školskog obveznika
  /// </summary>
  PreparatoryCourseApproved = 3,
  /// <summary>
  /// Odbijena pripremna ili dopunska nastava (UO/GU)<br/>
  /// UO/GU je donio odluku da se odbija provođenje pripremne ili dopunske nastave za školskog obveznika
  /// </summary>
  SupplementaryPreparatoryCourseRejected = 4,
  /// <summary>
  /// Kreiran zahtjev prema MZO<br/>
  /// Osnovna škola kojoj je odobreno provođenje pripremne ili dopunske nastave je kreirala zahtjev za suglasnost MZO-a
  /// </summary>
  RequestCreated = 5,
  /// <summary>
  /// Odobren zahtjev za pripremnu nastavu (MZO)<br/>
  /// MZO dao suglasnost na kreirani zahtjev škole
  /// </summary>
  PreparatoryCourseApprovedMinistry = 6,
  /// <summary>
  /// Odobren zahtjev za dopunsku nastavu (MZO)
  /// </summary>
  SupplementaryCourseApprovedMinistry = 7,
  /// <summary>
  /// Odbijen zahtjev za pripremnu nastavu (MZO)<br/>
  /// MZO nije dao suglasnost na kreirani zahtjev škole
  /// </summary>
  PreparatoryCourseRejectedMinistry = 8,
  /// <summary>
  /// Odbijen zahtjev za dopunsku nastavu (MZO)
  /// </summary>
  SupplementaryCourseRejectedMinistry = 9,
}
